'use strict'

import model from '@/model'

const get = async (uid) => {
  log('groupHandler.get()')
  return await model.group.get(uid)
}

const set = async (uid, email, group = 'member') => {
  log('groupHandler.set()')
  const prevGroup = await model.group.get(uid)
  if (prevGroup !== group) {
    await model.group.remove(uid, prevGroup)
    await model.current.setGroup(uid, group)
  }
  return await model.group.set(uid, email, group)
}

const remove = async (uid) => {
  log('groupHandler.remove()')
  return await model.group.remove(uid)
}

export default {
  get,
  set,
  remove
}
